import { useSelector, useDispatch } from "react-redux";
import { healthMetrics } from "./config";
import { ReusableCombobox } from "../../components/forms/ReusableCombobox";
import {
  setCommunityHealthDimension,
  setCommunityHealthFeature,
} from "../../store/districtPage";
import { Card } from "../../components/layouts/Cards";

const CommunityHealthContext = () => {
  const dispatch = useDispatch();
  const dimensionOptions = Object.keys(healthMetrics);

  const selectedDimension = useSelector(
    (state) => state.districtPage.communityHealth.selectedDimension
  );
  const selectedFeature = useSelector(
    (state) => state.districtPage.communityHealth.selectedFeature
  );

  const handleDimensionChange = (newDimension) => {
    dispatch(setCommunityHealthDimension(newDimension));
    // Set the first feature as default
    dispatch(setCommunityHealthFeature(healthMetrics[newDimension][0]));
  };

  const handleFeatureChange = (newFeature) => {
    dispatch(setCommunityHealthFeature(newFeature));
  };

  return (
    <Card className="p-4" colspan={12}>
      <div className="flex flex-col gap-8 font-inter">
        <div className="flex flex-col gap-1">
          <label
            className="text-lg font-medium text-slate-700 mb-3"
            htmlFor="community-health-category"
          >
            Category
          </label>
          <ReusableCombobox
            id="community-health-category"
            items={dimensionOptions}
            selected={selectedDimension}
            onSelect={handleDimensionChange}
            className="min-w-[220px]"
            placeholder="Select Category"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label
            className="text-lg font-medium text-slate-700 mb-1"
            htmlFor="community-health-indicator"
          >
            Indicator
          </label>
          <ReusableCombobox
            id="community-health-indicator"
            items={selectedDimension ? healthMetrics[selectedDimension] : []}
            selected={selectedFeature}
            onSelect={handleFeatureChange}
            className="min-w-[220px]"
            placeholder="Select Indicator"
          />
        </div>
      </div>
    </Card>
  );
};

export { CommunityHealthContext };
